import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconMeetings from './nav-icon-meetings.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconMeetings {...validProps} />;
}
SvgComponent.iconName = 'navIconMeetings';

export const NavIconMeetingsIcon = svgIconWrapper(SvgComponent);
